module.exports = __webpack_public_path__ + "static/media/icon_menu_active.0662316e.svg";